<template>
  <div>

  <header>
            <Header
        :HideCart='false'
        Title='Pedido enviado'
        class="mb-5" 
        />
  </header>

  <section style="max-height:99vh">


    <form class='register'>



      <CenteredFigure
      class='centered'
      :Img='FinishOrderImg'
      />

      <div class='card-body'>
        <h4 class='card-title princing-card-title text-center'>Recebemos seu pedido.</h4>
        <ul class="list-unstyled  text-center">
              <li>Muito obrigado</li>
              <li>Em breve um de nossos vendedores entrará em contato.</li>
            </ul>
      </div>


  
<FooterContainer>



        <ButtonOutline
        id='first_button'
        Type='submit'
        Text='IR PARA PAGINA INICIAL'
        :ButtonFunction='go_home'
        />

        
        <Button
        id='first_button'
        Type='submit'
        Text='ACOMPANHAR PEDIDO'
        :ButtonFunction='go_pedidos'
        />



</FooterContainer>

    </form>

  </section>
  </div> 
</template>

<script>

import Header from '../../components/Header/Header'
import FinishOrderImg from '../../assets/img/finish_order.svg'
import CenteredFigure from '../../components/ImageStyle/CenteredFigure'
import ButtonOutline from '../../components/Button/ButtonCallToActionOutline'
import Button from '../../components/Button/ButtonCallToAction'
import FooterContainer from '../../components/Container/FooterContainer'

export default {
  components: {

    Header,
    CenteredFigure,
    ButtonOutline,
    FooterContainer,
    Button,
  },
  data() {
    return {
      FinishOrderImg: FinishOrderImg,
      form: {
        nome: '',
        email: '',
        celular: '',
      }
    }
  },
  methods: {
    go_home() {
      this.$router.push({name:'home'})
    },
    go_pedidos() {
      this.$router.push({name:'acompanhar_pedido'})
    },
  },

}
</script>

<style scoped lang="css">



.titleh1{
  display: flex;
  align-items: center;
  text-align: center;
}

.inputName{
  margin-top:5.25rem;
}

#first_button{
  margin-bottom:.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:6.25rem;  
}

  @media (min-width: 1400px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }
</style>
